import { render, staticRenderFns } from "./mdInList.vue?vue&type=template&id=2995bc67&scoped=true"
import script from "./mdInList.vue?vue&type=script&lang=js"
export * from "./mdInList.vue?vue&type=script&lang=js"
import style0 from "./mdInList.vue?vue&type=style&index=0&id=2995bc67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2995bc67",
  null
  
)

export default component.exports